// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.limain
{
    height:91vh;
    width:100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    gap:50px;
    color:white;
}
.error_msg{
  font-size: 20px;
  color: white;
  text-align:center ;
  margin-top: 40px;
}
.license_container{
  height: 100vh;
  width: 100%;
  background-color: white;
}

.filter-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top:40px;
  margin-right: 100px;
}

.filter-dropdown {
  margin-right: 20px;
}
.stats_container{
  display: flex;
  justify-content: center;
  margin-top: 70px;
}

label {
  margin-right: 5px;
  color: white;
}

select {
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.submit-button {
  padding: 8px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 100px;
}

.submit-button:hover {
  background-color: #0056b3;
}

.customer_software{
  position: absolute;
  width: 180px;
  
  background-color: white;
  border-radius: 4px;
  color:black;
  top: 120px;
  margin:20px;
  padding: 20px;
  
}



.licard
{
    width:200px;
    height:200px;
    
}

.nnav
{
    width:100%;
    color: white;
    height:50px;
    display: flex;
    align-items: center;
    /* padding-left: 80px; */
    margin-top: 10px;
}
.navbar1{
  width: 200px;
}

.bellbtn {
    width: 50px;
    height: 50px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #9BB8CD;
    border-radius: 50%;
    cursor: pointer;
    transition-duration: .3s;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.13);
    border: none;
    margin-left: 380px;
    margin-top: 20px;
    
  }
  
  .bell {
    width: 18px;
  }
  
  .bell path {
    fill: white;
  }
  
  .bellbtn:hover {
    background-color: rgb(56, 56, 56);
  }
  
  .bellbtn:hover .bell {
    animation: bellRing 0.9s both;
  }
  
  /* bell ringing animation keyframes*/
  @keyframes bellRing {
    0%,
    100% {
      transform-origin: top;
    }
  
    15% {
      transform: rotateZ(10deg);
    }
  
    30% {
      transform: rotateZ(-10deg);
    }
  
    45% {
      transform: rotateZ(5deg);
    }
  
    60% {
      transform: rotateZ(-5deg);
    }
  
    75% {
      transform: rotateZ(2deg);
    }
  }
  
  .bellbtn:active {
    transform: scale(0.8);
  }
  .hh1
  {
    font-size:25px;
    margin-left: 200px;
    
  }`, "",{"version":3,"sources":["webpack://./src/components/Licensetab.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,WAAW;AACf;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;;EAEZ,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,aAAa;;AAEf;;;;AAIA;;IAEI,WAAW;IACX,YAAY;;AAEhB;;AAEA;;IAEI,UAAU;IACV,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;AACpB;AACA;EACE,YAAY;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,4CAA4C;IAC5C,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;;EAElB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,oCAAoC;EACpC;IACE;;MAEE,qBAAqB;IACvB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,wBAAwB;IAC1B;EACF;;EAEA;IACE,qBAAqB;EACvB;EACA;;IAEE,cAAc;IACd,kBAAkB;;EAEpB","sourcesContent":[".limain\r\n{\r\n    height:91vh;\r\n    width:100%;\r\n    background-color: white;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap:50px;\r\n    color:white;\r\n}\r\n.error_msg{\r\n  font-size: 20px;\r\n  color: white;\r\n  text-align:center ;\r\n  margin-top: 40px;\r\n}\r\n.license_container{\r\n  height: 100vh;\r\n  width: 100%;\r\n  background-color: white;\r\n}\r\n\r\n.filter-container {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  margin-top:40px;\r\n  margin-right: 100px;\r\n}\r\n\r\n.filter-dropdown {\r\n  margin-right: 20px;\r\n}\r\n.stats_container{\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 70px;\r\n}\r\n\r\nlabel {\r\n  margin-right: 5px;\r\n  color: white;\r\n}\r\n\r\nselect {\r\n  padding: 5px;\r\n  border-radius: 5px;\r\n  border: 1px solid #ccc;\r\n}\r\n\r\n.submit-button {\r\n  padding: 8px 20px;\r\n  background-color: #007bff;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  margin-right: 100px;\r\n}\r\n\r\n.submit-button:hover {\r\n  background-color: #0056b3;\r\n}\r\n\r\n.customer_software{\r\n  position: absolute;\r\n  width: 180px;\r\n  \r\n  background-color: white;\r\n  border-radius: 4px;\r\n  color:black;\r\n  top: 120px;\r\n  margin:20px;\r\n  padding: 20px;\r\n  \r\n}\r\n\r\n\r\n\r\n.licard\r\n{\r\n    width:200px;\r\n    height:200px;\r\n    \r\n}\r\n\r\n.nnav\r\n{\r\n    width:100%;\r\n    color: white;\r\n    height:50px;\r\n    display: flex;\r\n    align-items: center;\r\n    /* padding-left: 80px; */\r\n    margin-top: 10px;\r\n}\r\n.navbar1{\r\n  width: 200px;\r\n}\r\n\r\n.bellbtn {\r\n    width: 50px;\r\n    height: 50px;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: #9BB8CD;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    transition-duration: .3s;\r\n    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.13);\r\n    border: none;\r\n    margin-left: 380px;\r\n    margin-top: 20px;\r\n    \r\n  }\r\n  \r\n  .bell {\r\n    width: 18px;\r\n  }\r\n  \r\n  .bell path {\r\n    fill: white;\r\n  }\r\n  \r\n  .bellbtn:hover {\r\n    background-color: rgb(56, 56, 56);\r\n  }\r\n  \r\n  .bellbtn:hover .bell {\r\n    animation: bellRing 0.9s both;\r\n  }\r\n  \r\n  /* bell ringing animation keyframes*/\r\n  @keyframes bellRing {\r\n    0%,\r\n    100% {\r\n      transform-origin: top;\r\n    }\r\n  \r\n    15% {\r\n      transform: rotateZ(10deg);\r\n    }\r\n  \r\n    30% {\r\n      transform: rotateZ(-10deg);\r\n    }\r\n  \r\n    45% {\r\n      transform: rotateZ(5deg);\r\n    }\r\n  \r\n    60% {\r\n      transform: rotateZ(-5deg);\r\n    }\r\n  \r\n    75% {\r\n      transform: rotateZ(2deg);\r\n    }\r\n  }\r\n  \r\n  .bellbtn:active {\r\n    transform: scale(0.8);\r\n  }\r\n  .hh1\r\n  {\r\n    font-size:25px;\r\n    margin-left: 200px;\r\n    \r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
